import { createFileRoute } from '@tanstack/react-router'

import { SubscriptionV2LandingPage } from '../../../components/pages/subscription-v2/subscription-v2-landing-page.tsx'

export const Route = createFileRoute('/subscribe/landing')({
  component: () => <SubscriptionV2LandingPage />,
})
